"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var session_id_serialiser_1 = require("./../../session/session-id-serialiser");
/**
 * Serialiser for {@link MessagingClientSendRequest}
 */
var MessagingClientSendRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(MessagingClientSendRequestSerialiserClass, _super);
    function MessagingClientSendRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link MessagingClientSendRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link MessagingClientSendRequest} to be written
     */
    MessagingClientSendRequestSerialiserClass.prototype.write = function (bos, value) {
        session_id_serialiser_1.SessionIdSerialiser.write(bos, value.sessionId);
        Codec.writeString(bos, value.path);
        Codec.writeString(bos, value.dataType);
        Codec.writeBytes(bos, value.request);
    };
    return MessagingClientSendRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.MessagingClientSendRequestSerialiserClass = MessagingClientSendRequestSerialiserClass;
/**
 * The {@link MessagingClientSendRequest} singleton
 */ // tslint:disable-next-line:variable-name
exports.MessagingClientSendRequestSerialiser = new MessagingClientSendRequestSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/control/messaging-client-send-request-serialiser.js
// module id = 1333
// module chunks = 0